import React from "react";
import "./Spinner.css"

const Spinner = () => {
    return (
        <div className="AppSpinner">
            <div aria-label="Roller" className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Spinner